import Vue from "vue";
import Vuex from "vuex";

// import memu from './modules/memu'
// import question from './modules/question'
// import createVuexAlong from 'vuex-along'
// import userInfo from './modules/userInfo'
// import getters from './getters'

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    solutionId: null
  },
  mutations: {
    setMemu(state,obj){
      state[obj.name] = obj.value
    },
  },
  actions: {},
  // plugins: [createVuexAlong({
  //   name: "initAlone",
  //   local: {
  //     list: ["memu", "userInfo", "question"],
  //     isFilter: true // 过滤list 数据， 将其他的存入 localStorage
  //   },
  //   session: {
  //     list: ["memu", "userInfo", "question"] // 保存 list 到 sessionStorage
  //   }
  // })],
  // modules: {
  //   memu,
  //   userInfo,
  //   question
  // },
  // getters
});



// WEBPACK FOOTER //
// ./src/store/index.js